import { axiosTemplate } from '../../axiosTemplate';
import { getDatabilityIndex } from '../../utils/getDatabilityIndex';
import { endpoints } from './endpoints';
export const getCfjsonBatcher = async (getCfjsonsQueries) => {
    const databilities = getCfjsonsQueries.reduce((databilities, { datability }) => {
        return [...databilities, datability];
    }, []);
    const response = await fetch(`${endpoints[getCfjsonsQueries[0].stage]}/getCfjsons`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getCfjsonsQueries[0].metjwt}`,
            ...getCfjsonsQueries[0].headers,
        },
        body: JSON.stringify({
            databilities,
        }),
        signal: getCfjsonsQueries[0].signal,
    });
    const cfjsonsResponse = (await response.json());
    return databilities.map((datability) => {
        const databilityIndex = getDatabilityIndex(datability);
        const response = cfjsonsResponse.data.find((d) => d.databilityIndex === databilityIndex);
        if (response === undefined)
            throw new Error('databilityIndex is out of sync - this is serious, please report this to the platforms team');
        return response;
    });
};
export const getDatasetBatcher = async (queries) => {
    const { metjwt, stage, headers } = queries[0];
    const getDatasetsResponse = await axiosTemplate(metjwt, undefined, headers).post(`${endpoints[stage]}/v2/getDatasetsByIds`, {
        datasetIds: queries.map((a) => a.datasetId),
    });
    return queries.map((query) => {
        const response = getDatasetsResponse.data.find((d) => d.id === query.datasetId);
        if (response === undefined)
            throw new Error('There is no dataset for this dataset id: ' + query.datasetId);
        return response;
    });
};
